export default {"src":"/_next/static/media/eu-expansion-icon.3865178b.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};